module.exports = __webpack_public_path__ + "static/media/arrow_top.17e2166e.svg";